import React, { useState } from "react";
import { motion } from "framer-motion";
import Canadaimport from "@/pages/canadaimport";
import Contacts from "@/pages/contacts";
import Canadafaq from "@/pages/canadafaq";

function Canada() {
  
  const iconBoxes = [
    {
      icon: "multi.png",
      title: "Skilled Migration Visa",
      description:
        "The Federal Skilled Workers Program offers skilled professionals a pathway to Canadian residency.",
      href: "/skilledmigrationvisa",
    },
    {
      icon: "investorr.png",
      title: "Investor Visa",
      description:
        "Canada's Investor Visa helps entrepreneurs start businesses and secure permanent residency.",
      href: "/investorvisa",
    },
    {
      icon: "student.png",
      title: "Student Visa",
      description:
        "Canada's world-class education, inclusivity and diversity attract international students.",
      href: "/studentvisa",
    },
    {
      icon: "visit.png",
      title: "Visit Visa",
      description:
        "Canada provides temporary visas for tourism, family visits, business purposes and conferences.",
      href: "/visitvisa",
    },
  ];

  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <>
      <div className="h-98 relative w-full">
        <img
          src="canadas.jpg" // Replace with the correct path to your image
          alt="Canada Immigrations"
          className="h-full w-full object-cover"
        />
        <div className="absolute bottom-5 left-5 text-xl font-bold text-white drop-shadow-md md:text-4xl">
          Canada Immigrations
        </div>
      </div>

      <div>
        <div className="mt-32 w-full px-5 md:mt-20 md:w-full md:px-20 lg:mt-32 xl:mt-32">
          <p className="mb-5 text-center text-2xl font-bold text-[#011473] md:text-6xl">
            Visa Categories
          </p>

          <div className="container mx-auto mb-10 mt-14">
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-4 xl:grid-cols-4">
              {/* Skilled Migration Visa */}
              <div className="hover:shadow-xl group relative flex  h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/img.jpg"
                  alt="Skilled Migration Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Skilled Migration Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-lg">
                    The Federal Skilled Workers Program offers skilled
                    professionals a pathway to Canadian residency.
                  </p>
                  <a href="/canada-skilled-migration-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Investor Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/investor.jpg"
                  alt="Investor Visa"
                  className="mb-4 h-96 w-60 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Investor Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-lg">
                    Canada's Investor Visa helps entrepreneurs start businesses
                    and secure permanent residency.
                  </p>
                  <a href="/canada-investor-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Student Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/student.jpg"
                  alt="Student Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Student Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-lg">
                    Canada's world-class education, inclusivity and diversity
                    attract international students.
                  </p>
                  <a href="/canada-student-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>

              {/* Visit Visa */}
              <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
                <img
                  src="/visit.jpg"
                  alt="Visit Visa"
                  className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
                />
                <h2 className="text-xl font-medium text-[#011473] transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                  Visit Visa
                </h2>
                <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="mb-4 text-center text-lg">
                    Canada provides temporary visas for tourism, family visits,
                    business purposes and conferences.
                  </p>
                  <a href="/canada-visit-visa">
                    <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-5xl rounded-lg bg-white  p-6">
          <h2 className="mb-4 text-2xl font-semibold text-[#011473]">
            Benefits of Moving to Canada
          </h2>
          <p className="text-md leading-relaxed text-gray-700">
            Canada offers numerous advantages for immigrants, including access
            to subsidized government services such as healthcare, education, and
            transportation. Additionally, Canada’s immigration policies provide
            a straightforward pathway to citizenship, allowing individuals to
            apply and settle permanently within three years of residency.
          </p>
        </div>

        <div className="flex flex-col items-center px-4 py-10 lg:flex-row lg:items-start lg:space-x-12 lg:px-16">
          {/* Image Section */}
          <div className="flex w-full justify-center   md:pt-10 lg:w-1/2 lg:pr-6">
            <img
              src="/skilledcanada.jpg"
              alt="Project-Based Augmentation"
              className="shadow mb-10 h-auto w-3/4 rounded lg:w-full"
            />
          </div>

          {/* Text Section */}
          <div className="w-full space-y-4 lg:w-1/2 lg:pl-6">
            {[
              "Experience life, work and education across Canada's diverse provinces and territories.",
              "Benefit from free education for your children at top institutions in Canada.",
              "Access comprehensive healthcare and retirement support for you and your family.",
              "Benefit from an expedited, seamless relocation process to beautiful and welcoming Canada.",
              "Earn a better income in Canadian dollars, paving the way for financial success.",
              "Sponsor your loved ones to join you in Canada and enjoy a better quality of life together.",
              "Enjoy full Canadian rights and freedoms, ensuring equality and protection for all.",
              "Receive legal protection and benefit from Canada’s renowned justice system.",
            ].map((text, index) => (
              <div key={index} className="flex items-center">
                <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-blue-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 text-blue-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <span className="ml-4 text-sm font-medium text-gray-700 lg:text-base">
                  {text}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-4xl">
          <p className="text-md text-gray-700">
            A Canadian passport provides you with visa-free access to 172
            countries, offering unparalleled travel freedom. By applying for a
            Canadian Tourist Visa or Visit Visa from Dubai, you can explore the
            country's natural beauty and vibrant cities.
          </p>
          <br />
          <p className="text-md text-gray-700">
            One of the most compelling reasons to immigrate to Canada is the
            availability of subsidized government services, including
            healthcare, education and public transportation. Additionally,
            Canada offers a streamlined path to citizenship, allowing immigrants
            to apply for citizenship and gain permanent residency after just
            three years of living in the country. This makes it easier for
            newcomers to establish themselves and build a prosperous future.
          </p>
        </div>

        <Canadaimport />

        <Canadafaq />
        <Contacts />
      </div>
    </>
  );
}

export default Canada;
